<template>
    <div class="container trash">
      <div class="header card">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item>内容管理</el-breadcrumb-item>
          <el-breadcrumb-item>资源管理</el-breadcrumb-item>
          <el-breadcrumb-item>内容回收站</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content">
          <div class="left">
            <h2 class="title">内容回收站</h2>
          </div>
          <div class="right"></div>
        </div>
      </div>
      <div class="results card">
        <el-tabs v-model="query.tabKey" @tab-click="handleTabChange">
          <el-tab-pane label="信息资讯" name="article"></el-tab-pane>
          <el-tab-pane label="在线题库" name="exam"></el-tab-pane>
          <el-tab-pane label="阅读资料" name="read"></el-tab-pane>
          <el-tab-pane label="在线课程" name="course"></el-tab-pane>
          <el-tab-pane label="实体资料" name="material"></el-tab-pane>
        </el-tabs>
        <div class="values" v-if="query.tabKey == 'material'">
          <MaterialCard class="trash-item" :content="item" @submit="fetchTrashList" v-for="item in results" :key="item.id"/>
        </div>
        <div class="values" v-if="query.tabKey == 'exam'">
          <ExamCard class="trash-item" :content="item" @submit="fetchTrashList" v-for="item in results" :key="item.id"/>
        </div>
        <div class="values" v-if="query.tabKey == 'course'">
          <CourseCard class="trash-item" :content="item" @submit="fetchTrashList" v-for="item in results" :key="item.id"/>
        </div>
        <div class="values" v-if="query.tabKey == 'read'">
          <ReadCard class="trash-item" :content="item" @submit="fetchTrashList" v-for="item in results" :key="item.id"/>
        </div>
        <div class="values" v-if="query.tabKey == 'article'">
          <ArticleCard class="trash-item" :content="item" @submit="fetchTrashList" v-for="item in results" :key="item.id"/>
        </div>
        <div class="footer">
          <el-pagination
            background
            layout="total, prev, pager, next, sizes, jumper"
            :current-page="Number(query.pageIndex)"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="Number(query.pageSize)"
            :total="Number(pageTotal)"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
</template>

<script>
import MaterialCard from '@/components/trash/Material'
import ExamCard from '@/components/trash/Exam'
import CourseCard from '@/components/trash/Course'
import ArticleCard from '@/components/trash/Article'
import ReadCard from '@/components/trash/Read'
import { materialList } from '@/api/material'
import { examList } from '@/api/exam'
import { courseList } from '@/api/course'
import { articleList } from '@/api/article'
import { readList } from '@/api/read'

export default {
  components: {
    MaterialCard,
    ExamCard,
    CourseCard,
    ArticleCard,
    ReadCard
  },
  data() {
    return {
      tabKey: 'article',
      query: {
        tabKey: 'article',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      results: []
    }
  },
  created() {
    this.parseQuery()
    this.fetchTrashList()
  },
  methods: {
    // 资料列表请求
    fetchMaterialList() {
      materialList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 内容列表请求
    fetchTrashList() {
      const apis = {
        'article': articleList,
        'exam': examList,
        'read': readList,
        'course': courseList,
        'read': readList,
        'material': materialList
      }
      const params = Object.assign({}, this.query, {_delete: 1})
      apis[this.query.tabKey](params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // tab切换
    handleTabChange(tab) {
      this.query.tabKey = tab.name
      this.query.pageIndex = 1
      this.results = []
      this.fetchTrashList()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchTrashList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchTrashList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
      if (!this.query.tabKey) {
        this.query.tabKey = 'article'
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.trash {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {

    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .results {
    margin-top: 10px;

    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-top: 10px;
    }
    .trash-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
